<template>
  <div class="order-payment-details-message"
       :title="datetime">
    <text-string v-bind="textStringLabelIdProps" class="m-b-15"/>

    <smd-btn section="4"
             variant="red-enabled"
             @click="sendProofOfPayment">
      <text-string label-id="txt115" />
    </smd-btn>

    <p class="time">{{ formattedTime }}</p>
  </div>
</template>

<script>
  import {formatDate} from '@/utils/dates';
  import OrderMessageParserMixin from '@/mixins/messages/order-message-parser-mixin';

  export default {
    name: 'order-payment-details-message',
    mixins: [
      OrderMessageParserMixin,
    ],
    props: {
      message: {type: Object, required: true},
    },
    data() {
      return {
        paymentDetails: JSON.parse(this.message.msg),
      };
    },
    computed: {
      datetime() {
        return formatDate(this.message.date, 'MMMM D, YYYY hh:mm a');
      },
      formattedTime() {
        return formatDate(this.message.date, 'h:mm a');
      },
      textStringLabelIdProps() {
        return this.getPaymentDetailsLabelProps(this.paymentDetails);
      },
    },
    methods: {
      sendProofOfPayment() {
        this.$emit('emitSendProofOfPayment');
      },
    },
  }
</script>

<style lang="scss">
  .order-payment-details-message {
    border-radius: radius(medium);
    padding: space(s) space(m);
    background-color: color(gray-50);

    button {
      display: block;
      margin: 0 auto space(m) auto;
    }

    .time {
      font-size: font(s);
    }
  }
</style>